module.exports = __webpack_public_path__ + "static/media/galerija_2017 (24).b88d58ec.jpg";